














































import { defineComponent } from "@vue/composition-api";
import { PropType } from "vue";
import { ModuleVerticalOption } from "~/utils/types/Plan";
import { SfIcon } from "@storefront-ui/vue";
import { addBasePath } from "~/helpers/addBasePath";

export default defineComponent({
  components: {
    SfIcon,
  },
  props: {
    modulesSkus: {
      type: Array,
      required: true,
    },
    item: {
      type: Object as PropType<ModuleVerticalOption>,
    },
    toggleSelectModule: {
      type: Function,
      required: true,
    },
    color: {
      type: String
    },
    textColor: {
      type: String
    }
  },
  setup(props){
    return { 
      placeholderImage : addBasePath('/resources/favicons/icon-120x120.jpg'),
      mediaGallery: props.item.product?.media_gallery.filter(el=>!el.disabled)
    }
  }
});
